import client from './client';
import { User } from '../types/entities';
import { ApiResponse, LoginRequest } from '../types/api';

// Auth API returns user directly (not wrapped in data)
interface AuthResponse {
  success: boolean;
  message?: string;
  user?: User;
  error?: string;
}

export const authAPI = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await client.post('/auth/login', credentials);
    return response.data;
  },

  logout: async (): Promise<ApiResponse<null>> => {
    const response = await client.post('/auth/logout');
    return response.data;
  },

  getCurrentUser: async (): Promise<AuthResponse> => {
    const response = await client.get('/auth/me');
    return response.data;
  },

  changePassword: async (data: { currentPassword: string; newPassword: string }): Promise<ApiResponse<null>> => {
    const response = await client.put('/auth/change-password', data);
    return response.data;
  },
};
